window.html2canvas = require('html2canvas');

/**
 * Third party JS
 */
import _ from 'lodash';
import 'faker';
import 'clipboard';
//import './vendor/jquery.basictable.min';

import ClassicEditor from 'ckeditor5-build-full';
window.ClassicEditor = ClassicEditor;


/**
 * Own JS
 */
import './_Next/EventListeners';
import './_Next/BasicBootstrap';
import './_Next/TriggerNative';
import './_Next/AuxiliaryFunctions';